import {call, fork, put, select, take} from 'redux-saga/effects';
import _ from 'lodash';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get send letter
 * */
function* getSendLetterList(pagination = {}) {
    const store = yield select();
    let response = {};

    try {
        response = yield call(api.getSendEmailList, _.merge(store.senderList, pagination));
    } catch(error) {
        yield put({
            type: actionTypes.GET_SEND_EMAIL_LIST.FAILURE,
            errors: response.data,
            error: error,
        });

        return response.data;
    }

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_SEND_EMAIL_LIST.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_SEND_EMAIL_LIST.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetSendLetterList() {
    while (true) {
        const { pagination } = yield take(actionTypes.GET_SEND_EMAIL_LIST.REQUEST);
        yield fork(getSendLetterList, pagination);
    }
}

/**
 * Get send letter
 * */
export function* getSendLetter(id) {
    const response = yield call(api.getSendEmail, id);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_SEND_EMAIL.SUCCESS,
            data: response.data.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_SEND_EMAIL.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetSendLetter() {
    while (true) {
        const { id } = yield take(actionTypes.GET_SEND_EMAIL.REQUEST);
        yield fork(getSendLetter, id);
    }
}


export default [
    watchGetSendLetterList,
    watchGetSendLetter,
];




// WEBPACK FOOTER //
// ./app/sagas/sender.js